import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Ticket } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { RedeemTrialDialog } from '@/components/RedeemTrialDialog';

/**
 * Button that opens the Redeem Trial Code dialog.
 */
export function RedeemTrialCodeButton() {
  const { t } = useLanguage();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button variant={"outline"} size={"sm"} onClick={() => { setDialogOpen(true); }}>
        <Ticket className="h-4 w-4 mr-2" />
        {t.billing.redeemTrialCode}
      </Button>
      <RedeemTrialDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  );
}
